import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import CartDrawer from './CartDrawer';
import SearchOverlay from './SearchOverlay';
import WhatsAppButton from './WhatsAppButton';
import Toast from './common/Toast';

export default function Layout() {
    const location = useLocation();
    const isHome   = location.pathname === '/';

    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#F4F8EC' }}>
            <Navbar />

            {/* Home: the hero tile starts 12px under the announcement bar and the glass nav floats inside it. */}
            {/* Interior pages: clear the floating nav (announcement bar is in flow above). */}
            <main style={{ flex: 1, paddingTop: isHome ? 12 : 108 }}>
                <Outlet />
            </main>

            <Footer />
            <SearchOverlay />
            <CartDrawer />
            {/* LiveChat is off until it is connected to a real inbox — it used to
                show an auto-reply while messages went nowhere. */}
            <WhatsAppButton />
            <Toast />
        </div>
    );
}
